import { cx } from '@linaria/core';
import { centerCls, textColumnCls } from '@pm2/react-utils';
import { pm2ConfigStore } from '@pm2/store';
import { useUserIdentityState, userIdentityManager } from '@provider/user-identity';
import { Link, LinkButton } from '@ui/kit';
import { containerCls, textCls as textCls$1, linkCls, secondaryLinkCls, iconCls } from './message.access.style.js';
import { headingCls, textCls, buttonWrapperCls } from './message.base.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

const FREE_ACCESS_MSG = /*#__PURE__*/jsx(Fragment, {
  children: "Denne side er gratis, men du skal v\xE6re logget ind for at se indholdet."
});
const LOGIN_REQUIRED_MSG = /*#__PURE__*/jsx(Fragment, {
  children: "Du skal v\xE6re logget ind for at se sidens indhold. Har du ikke licens til dette l\xE6remiddel, kan du se mere p\xE5 gyldendal-uddannelse.dk om dine muligheder for at f\xE5 adgang."
});
const LICENSE_REQUIRED_GLOBAL_MSG = /*#__PURE__*/jsx(Fragment, {
  children: "Du har desv\xE6rre ikke adgang til dette l\xE6remiddel. Se mere p\xE5 gyldendal-uddannelse.dk og l\xE6s om dine muligheder for at f\xE5 adgang."
});
const LICENSE_REQUIRED_PAGE_MSG = /*#__PURE__*/jsx(Fragment, {
  children: "Du har desv\xE6rre ikke adgang til denne side. Se mere p\xE5 gyldendal-uddannelse.dk og l\xE6s om dine muligheder for at f\xE5 adgang."
});
/**
 * displays an error message notifying the user that he's currently not
 * authorized to view the page he's visiting.
 */
const MissingAccessMessage = props => {
  const user = useUserIdentityState(state => state.user);
  const trialAccessUrlRaw = pm2ConfigStore.useSelector(state => state.config.settings.trialAccessUrl);
  const loginFreeAccess = pm2ConfigStore.useSelector(state => state.config.settings.loginFreeAccess);
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  const portalTitle = pm2ConfigStore.useSelector(state => state.config.title);
  const trialAccessUrl = trialAccessUrlRaw?.includes("//") ? trialAccessUrlRaw : `https://${trialAccessUrlRaw}`;
  const message = loginFreeAccess ? FREE_ACCESS_MSG : !user ? LOGIN_REQUIRED_MSG : props.requiredLicenseType === "page" ? LICENSE_REQUIRED_PAGE_MSG : LICENSE_REQUIRED_GLOBAL_MSG;
  const showLoginLink = !user && !loginDisabled;
  const showTrialAccessLink = !loginFreeAccess && !!trialAccessUrlRaw;
  const showCustomerSupportLink = !showLoginLink;
  return /*#__PURE__*/jsx("div", {
    className: cx(centerCls, containerCls),
    children: /*#__PURE__*/jsxs("div", {
      className: cx(textColumnCls, "nestedCenter"),
      children: [/*#__PURE__*/jsxs("h1", {
        className: headingCls,
        children: ["Velkommen til ", portalTitle]
      }), /*#__PURE__*/jsx("p", {
        className: cx(textCls, textCls$1),
        children: message
      }), /*#__PURE__*/jsxs("div", {
        className: buttonWrapperCls,
        children: [showTrialAccessLink && /*#__PURE__*/jsx(Link, {
          theme: "primary",
          className: cx(linkCls, secondaryLinkCls),
          href: trialAccessUrl,
          target: "_blank",
          rel: "noreferrer noopener",
          children: "G\xE5 til gyldendal-uddannelse.dk"
        }), showCustomerSupportLink && /*#__PURE__*/jsx(Link, {
          theme: "primary",
          className: cx(linkCls, secondaryLinkCls),
          href: "https://gyldendal-uddannelse.dk/kundeservice",
          target: "_blank",
          rel: "noreferrer noopener",
          children: "Kontakt kundeservice"
        }), showLoginLink && /*#__PURE__*/jsx(LinkButton, {
          theme: "primary",
          className: linkCls,
          onClick: userIdentityManager.requestLogin,
          children: "Log ind"
        })]
      }), /*#__PURE__*/jsx("svg", {
        className: iconCls,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 28 38.7",
        preserveAspectRatio: "xMaxYMax",
        children: /*#__PURE__*/jsxs("g", {
          children: [/*#__PURE__*/jsx("path", {
            d: "M7,13.5c0.3,0,0.5-0.2,0.5-0.5v-1.7C7.8,11.2,8,10.9,8,10.5c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.4,0.2,0.7,0.5,0.8V13C6.5,13.3,6.7,13.5,7,13.5z M7,10.5C7,10.5,7,10.5,7,10.5C7,10.5,7,10.5,7,10.5l-0.5,0L7,10.5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M13,8v4.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C14,7.2,13.8,7,13.5,7H12V5c0-2.8-2.2-5-5-5S2,2.2,2,5v2H0.5C0.2,7,0,7.2,0,7.5v10C0,17.8,0.2,18,0.5,18h1C1.8,18,2,17.8,2,17.5S1.8,17,1.5,17H1V8H13z M3,5c0-2.2,1.8-4,4-4s4,1.8,4,4v2H3V5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M27.5,14.7h-23C4.2,14.7,4,15,4,15.2v23c0,0.3,0.2,0.5,0.5,0.5h23c0.3,0,0.5-0.2,0.5-0.5v-23C28,15,27.8,14.7,27.5,14.7zM27,37.7H5v-22h22V37.7z"
          }), /*#__PURE__*/jsx("path", {
            d: "M8,20.4h14.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H8c-0.3,0-0.5,0.2-0.5,0.5S7.7,20.4,8,20.4z"
          }), /*#__PURE__*/jsx("path", {
            d: "M8,23.5h12.5c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H8c-0.3,0-0.5,0.2-0.5,0.5S7.7,23.5,8,23.5z"
          }), /*#__PURE__*/jsx("path", {
            d: "M8,26.6h15.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H8c-0.3,0-0.5,0.2-0.5,0.5S7.7,26.6,8,26.6z"
          }), /*#__PURE__*/jsx("path", {
            d: "M8,29.7h15.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H8c-0.3,0-0.5,0.2-0.5,0.5S7.7,29.7,8,29.7z"
          }), /*#__PURE__*/jsx("path", {
            d: "M8,32.8h12.5c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H8c-0.3,0-0.5,0.2-0.5,0.5S7.7,32.8,8,32.8z"
          })]
        })
      })]
    })
  });
};

export { MissingAccessMessage };
//# sourceMappingURL=message.access.js.map
